var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weixin-tip"},[_vm._m(0),_c('div',{staticClass:"weixin-bot"},[_vm._v(_vm._s(_vm.note))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weixin-top"},[_c('img',{attrs:{"src":require("../assets/images/weixin-arrow.png"),"alt":""}})])
}]

export { render, staticRenderFns }